import { AxiosInstance } from 'axios';
import { AgenciesRepository } from '@/model/repository/manager/agencies/AgenciesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AgenciesRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
